// ローディング画面の追加
 /*
	https://www.webcreatorbox.com/tech/loading-animation

	usang：
	body直下で以下のマークアップで読み込む。ローダーはお好みでどうぞ。
	<div id="loading">
		<div class="spinner"></div>
	</div>

	CSSで好きなように装飾してください。
	src/sass/theme_styles/component/c-loading.scss
	*/

window.onload = function() {
  const spinner = document.getElementById('loading');
  spinner.classList.add('loaded');
}
